import RixItemComm from './itemComm.rixItemComm.api';
export default RixItemComm;
